<template>
  <div class="list-sorting">
    <div class="card sorting-form collapse" id="list-sorting">
      <div class="card-body">
        <div class="form-group mb-3">
          <label class="text-muted d-block mb-2">Сортировка</label>
          <div class="row">
            <div
                v-for="option in sortingOptions"
                :key="option.key"
                class="col-md-3 mb-2"
            >
              <button
                  @click="selectSorting(option)"
                  :class="['btn d-flex align-items-center status-button w-100', isSelected(option) && 'btn-status-selected']"
                  type="button"
              >
        <span
            class="status-radio"
            :class="{ selected: isSelected(option) }"
        ></span>
                {{ option.label }}
              </button>
            </div>
          </div>
        </div>
        <div class="text-right">
          <button type="submit" class="btn btn-outline-success mr-1">
            Сортировать
          </button>
          <button @click="resetSorting" type="button" class="btn btn-outline-info">
            Сбросить
          </button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {filterStore} from "@/store/filterStore";

export default {
  name: "ListSorting",
  data() {
    return {
      sortingOptions: [
        {key: "createdAt-desc", field: "createdAt", order: "DESC", label: "Новые сначала"},
        {key: "createdAt-asc", field: "createdAt", order: "ASC", label: "Старые сначала"},
      ],
      filter: filterStore
    };
  },
  mounted() {
    this.resetSorting();
  },
  methods: {
    selectSorting(option) {
      this.filter.sorting = option.field;
      this.filter.order = option.order;
    },
    isSelected(option) {
      return (
          this.filter.sorting === option.field &&
          this.filter.order === option.order
      );
    },
    resetSorting() {
      this.filter.sorting = null;
      this.filter.order = null;
    }
  },
};
</script>

<style scoped>
.status-button {
  gap: 8px;
  padding: 6px 12px;
  border: 1px solid #e9ecef;
  box-shadow: none;
  border-radius: 4px;
  background-color: white;
  color: #212529;
  transition: all 0.2s ease;
}

.status-button:focus {
  outline: none;
  box-shadow: none;
}

.status-radio {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--green);
  box-shadow: 0 0 0 4px white inset;
  position: relative;
  top: 1px;
  flex-shrink: 0;
  transition: background-color 0.2s, box-shadow 0.2s;
}

.status-radio.selected {
  background: var(--green);
  box-shadow: 0 0 0 4px white inset;
}

.status-radio:not(.selected) {
  background: #e9ecef;
  box-shadow: 0 0 0 4px white inset;
}

.btn-status-selected {
  border-color: var(--green);
  color: var(--green);
  background-color: white;
  box-shadow: none;
}
</style>